<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{ data?.title }}</h3>
			</div>
			<div class="zesty-modal__content">
				<mat-form-field>
					<mat-label>Organization name</mat-label>
					<input matInput [formControl]="orgNameControl" placeholder="Enter your company name" />
				</mat-form-field>
			</div>
			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button
					class="zesty-modal__create-btn delete"
					(click)="createOrganization()"
					[disabled]="orgNameControl.invalid || (isLoading$ | async)"
				>
					Create
				</button>
			</div>
		</div>
	</div>
</div>
